import { EnterpriseSsoConfig } from '../../../environments/environment.model';

export function resolveEnterpriseSsoProviderId({
  enabled,
  providerId,
}: EnterpriseSsoConfig): string | null {
  if (!enabled) {
    return null;
  }
  return providerId.trim() || null;
}
